import {
  Button,
  Col,
  Radio,
  Spin,
  Tag,
} from "../../common/utils/antd-imports/AntdImports";
import FloatingSelect from "../../common/floating-select/floatingSelect";
import { useEffect, useState } from "react";
import {
  getAllBulkProducts,
  getAllSellers,
  getProductsPerUser,
  postTransferProducts,
} from "../../../store/thunks/seller-thunks/SellerThunk";
import { useDispatch, useSelector } from "react-redux";

const TransferProducts = ({
  openTransferDialog,
  setTransferDialog,
  setCurrentPage,
}) => {
  const dispatch = useDispatch();
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [selectedBukUploadUniqueId, setSelectedBukUploadUniqueId] =
    useState(null);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const productOptions =
    filteredProducts.length > 1
      ? [{ id: "select_all", name: "Select All" }, ...filteredProducts]
      : filteredProducts;
  const [selectedTransferProducts, setSelectedTransferProducts] = useState([]);
  const [selectedTab, setSelectedtab] = useState(1);
  const isDisabled =
    !selectedSeller ||
    (selectedTab === 1 && !selectedBukUploadUniqueId) ||
    (selectedTab === 2 && selectedTransferProducts.length === 0);

  const floatingSelectStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.6rem",
    "--input-padding-top": "1rem",
  };

  useEffect(() => {
    if (openTransferDialog) {
      dispatch(getAllSellers()).then(() => {
        dispatch(getAllBulkProducts()).then(() => {
          dispatch(getProductsPerUser());
        });
      });
    }
  }, [openTransferDialog]);

  const { isLoading, allBulkProducts, getAllSellersList, productsPerUser } =
    useSelector((state) => state.products);

  useEffect(() => {
    if (productsPerUser) {
      const v =
        productsPerUser &&
        productsPerUser?.map((product) => ({
          name: `${product?.title}`,
          id: product?.id,
        }));
      setFilteredProducts(v);
    }
  }, [productsPerUser]);

  const handleTransferProducts = () => {
    const formData = new FormData();
    formData.append("seller_id", selectedSeller);
    if (selectedBukUploadUniqueId && selectedBukUploadUniqueId !== "") {
      formData?.append("bulkupload_uniqueID", selectedBukUploadUniqueId);
    }
    if (selectedTransferProducts && selectedTransferProducts.length > 0) {
      selectedTransferProducts?.forEach((product, index) => {
        formData.append(`product_id_arr[${index}]`, product);
      });
      formData.append("bulkupload_uniqueID", "");
    }
    dispatch(postTransferProducts(formData))?.then((res) => {
      if (res?.payload?.status == 1) {
        setCurrentPage(1);
        setTransferDialog(false);
        setSelectedSeller(null);
        setSelectedBukUploadUniqueId(null);
        setFilteredProducts([]);
        setSelectedTransferProducts([]);
      }
    });
  };

  return (
    <>
      <div style={{ padding: "1rem" }}>
        <span className="transfer-product-header">Transfer Product</span>
        <br />
        <span style={{ fontFamily: "Roboto" }}>
          Effortlessly Transfer Your Products
        </span>
        <Col className="transfer-product-seller">
          <FloatingSelect
            showSearch
            filterOption={(input, option) =>
              option?.children.toLowerCase().includes(input.toLowerCase())
            }
            style={{ width: "100%" }}
            className="billboard-select-feild"
            isChannels={true}
            label={
              <>
                {`Select Seller`}
                {star}
              </>
            }
            isMultipleProduct={false}
            value={selectedSeller}
            onChange={(_e, value) => setSelectedSeller(value?.key)}
            options={getAllSellersList?.map((seller) => ({
              id: String(seller.seller_id),
              name: `${seller.first_name} ${seller.last_name} - ${seller.email}`,
            }))}
            customStyles={floatingSelectStyles}
          />
        </Col>
        <Col className="transfer-product-seller">
          <Radio.Group
            className="transfer-product-radio"
            value={selectedTab}
            options={[
              { value: 1, label: "Bulk Upload Unique ID" },
              { value: 2, label: "Select Product Manually" },
            ]}
            onChange={(e) => {
              if (selectedBukUploadUniqueId) {
                setSelectedBukUploadUniqueId(null);
              } else if (selectedTransferProducts) {
                setSelectedTransferProducts([]);
              }
              setSelectedtab(e.target.value);
            }}
          />
        </Col>
        {selectedTab === 1 ? (
          <Col>
            <FloatingSelect
              className="billboard-select-feild"
              label={
                <>
                  {`Bulk Upload Unique ID’s`}
                  {star}
                </>
              }
              value={selectedBukUploadUniqueId}
              onChange={(_e, value) =>
                setSelectedBukUploadUniqueId(value?.value)
              }
              options={allBulkProducts?.map((seller) => ({
                id: String(seller.id),
                name: `${seller.bulkupload_uniqueID}`,
              }))}
              customStyles={floatingSelectStyles}
            />
          </Col>
        ) : (
          <Col>
            <div>
              <FloatingSelect
                showSearch
                allowClear
                className="billboard-select-feild"
                label={
                  <>
                    {`Select the Product`}
                    {star}
                  </>
                }
                mode="multiple"
                loading={isLoading}
                isMultipleProduct={true}
                options={productOptions}
                optionFilterProp="label"
                value={
                  selectedTransferProducts.length === filteredProducts.length
                    ? ["select_all", ...selectedTransferProducts]
                    : selectedTransferProducts
                }
                customStyles={floatingSelectStyles}
                onChange={(_e, values) => {
                  const selectedValues = values?.map((item) => item.value);
                  const allProductIds = filteredProducts.map((p) => p.id);
                  const hasSelectAll = selectedValues.includes("select_all");
                  const prevAllSelected =
                    selectedTransferProducts.length === filteredProducts.length;
                  if (hasSelectAll && !prevAllSelected) {
                    setSelectedTransferProducts(allProductIds);
                    return;
                  }
                  if (
                    !hasSelectAll &&
                    prevAllSelected &&
                    selectedValues.length === filteredProducts.length
                  ) {
                    setSelectedTransferProducts([]);
                    return;
                  }
                  if (!hasSelectAll && prevAllSelected) {
                    const filtered = selectedValues.filter(
                      (v) => v !== "select_all",
                    );
                    setSelectedTransferProducts(filtered);
                    return;
                  }
                  const filteredSelectedValues = selectedValues.filter(
                    (value) => value !== "select_all",
                  );
                  setSelectedTransferProducts(filteredSelectedValues);
                }}
                filterSort={(optionA, optionB) => {
                  if (optionA.value === "select_all") return -1;
                  if (optionB.value === "select_all") return 1;
                  return (optionA?.label ?? "")
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? "").toLowerCase());
                }}
                tagRender={() => <></>}
              ></FloatingSelect>
            </div>
            <div className="my-billboard-tag-css">
              {selectedTransferProducts &&
                selectedTransferProducts?.length > 0 &&
                selectedTransferProducts?.map((transferProduct) => (
                  <Tag
                    key={transferProduct}
                    className="transfer-product-chip"
                    closable
                    onClose={(e) => {
                      e.preventDefault();
                      setSelectedTransferProducts(
                        selectedTransferProducts?.filter(
                          (chip) => chip !== transferProduct,
                        ),
                      );
                    }}
                  >
                    <span>
                      {
                        filteredProducts?.find(
                          (product) => product.id === transferProduct,
                        )?.name
                      }
                    </span>
                  </Tag>
                ))}
            </div>
          </Col>
        )}

        <div style={{ marginTop: "1rem" }}>
          <div className="billboard-buttons-div ">
            <Button
              className="billboard-buttons billboard-button-1"
              onClick={() => {
                setTransferDialog(false);
                setSelectedSeller(null);
                setSelectedBukUploadUniqueId(null);
                setFilteredProducts([]);
                setSelectedTransferProducts([]);
              }}
            >
              Cancel
            </Button>
            <Button
              className={`billboard-buttons billboard-button-2 ${
                isDisabled ? "disabled-opacity" : ""
              }`}
              onClick={() => {
                handleTransferProducts();
              }}
              disabled={isDisabled}
            >
              Transfer Now
            </Button>
          </div>
        </div>
      </div>
      {isLoading && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </>
  );
};

export default TransferProducts;
